import { type DocumentNode } from 'graphql';

import { type Settings } from './settings';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type SimpleQuery = Record<string, any>;

export type BaseParams<T = SimpleQuery> = {
    customQuery?: string;
    query?: T;
    settings?: Settings;
    prefetch?: () => Promise<string>;
};

export type GraphqlParams = {
    query: DocumentNode;
    settings?: Settings;
    prefetch?: () => Promise<string>;
};

export type CallParams<T> = BaseParams & T;
export type SortingDir = 'Asc' | 'Desc';

export interface PagingParams {
    page?: number;
    limit?: number;
    sort?: string;
    dir?: SortingDir;
    tags?: Record<string, string>;
    total?: number;
    // Any tag is allowed
    [key: string]: string | number | undefined | Record<string, string>;
}

export interface PaginatedResult<T> {
    data: T[];
    paging: PagingParams;
}
export type ContinuationResult<T> = T & { continuation: string };

// TODO type this any properly
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type RecordType = Record<string, string | number | Array<string | number> | any>;

export type PostParams<T = RecordType> = {
    value: T;
};

export type PatchParams<T = RecordType> = {
    value: T;
};

/** HTTP response status */
export interface HttpStatus {
    code: number;
    text: string;
}

/** Discard Edit response status */
export interface DiscardEditResult {
    success: boolean;
}

/** Standard settings for API call */
export const ApiRequestInit: RequestInit = {
    method: 'GET',
    headers: new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }),
    mode: 'cors',
    cache: 'no-cache',
    referrerPolicy: 'no-referrer-when-downgrade',
};

export enum DataProviders {
    API = 'API',
    DAAS = 'DAAS',
}
